import React from 'react';
import { connect } from 'react-redux';
import { View, Text } from 'react-native';

import withAuth from 'common/hoc/withAuth';

import login from 'modules/general/shared/action/login';
import { FAILED_AUTHENTICATION } from '../constants/loginCallbackMessageType';

const mapStateToProps = state => ({
  authState: state.general.auth,
});

const mapDispatchToProps = dispatch => ({
  login: authResult => dispatch(login(authResult)),
});

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

@withAuth
@connectToRedux
export default class CallbackScreen extends React.Component {
  componentDidMount() {
    this.checkCallback();
  }

  // https://stackoverflow.com/questions/326069
  inIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  checkCallback = async () => {
    try {
      const authResult = await this.props.auth.handleAuthentication();
      this.successAuth(authResult);
    } catch (err) {
      this.failedAuth(err);
    }
  };

  successAuth = authResult => {
    const jsonAuthResult = JSON.stringify(authResult);

    if (this.inIframe()) {
      window.parent.postMessage(jsonAuthResult, window.location.origin);
    } else {
      this.props.login(authResult);
      this.props.navigation.push('Home');
    }
  };

  failedAuth = error => {
    const jsonError = JSON.stringify({
      type: FAILED_AUTHENTICATION,
      error,
    });

    if (this.inIframe()) {
      window.parent.postMessage(jsonError, window.location.origin);
    } else {
      this.props.navigation.push('Login');
    }
  };

  static navigationOptions = {
    header: null,
  };

  render() {
    return (
      <View>
        <Text>Processing your login...</Text>
      </View>
    );
  }
}
